import { FaBars, FaTimes, FaGithub, FaLinkedin, FaBlog } from 'react-icons/fa';
import {  HiOutlineMail  } from 'react-icons/hi';
import { BsFillPersonLinesFill } from 'react-icons/bs';
import { Link } from 'react-scroll';
import { useState } from 'react';
import Logo from '../assets/logo.png';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  return (
    <div 
      className='sticky top-0 w-full h-[80px] flex justify-between
      items-center px-4 bg-[#3B6898] text-gray-300 shadow-md shadow-[#040c16]'
    >
      <div>
        <img src={Logo} alt='Logo Here' style={{ width: '50px' }} />
      </div>
      {/* Nav Menu */}
      <ul className='hidden md:flex'>
        <li className='hover:inline hover:border-b-4 hover:border-blue-600'>
          <Link to="home" smooth={true} duration={500}>
            Home
            </Link>
        </li>
        <li className='hover:inline hover:border-b-4 hover:border-blue-600'>
          <Link to="about" smooth={true} duration={500}>
            About
          </Link>
        </li>
        <li className='hover:inline hover:border-b-4 hover:border-blue-600'>
          <Link to="skills" smooth={true} duration={500}>
            Skills
          </Link>
          </li>
        <li className='hover:inline hover:border-b-4 hover:border-blue-600'>
         <Link to="projects" smooth={true} duration={500}>
            Projects
          </Link>
        </li>
        <li className='hover:inline hover:border-b-4 hover:border-blue-600'>
          <Link to="contact" smooth={true} duration={500}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Hamburger Menu */}
      <div className='md:hidden z-10' onClick={handleClick}>
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile Menu */}
      <ul 
        className={
          nav ? 'absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center' : 
          'hidden'
        }
      >
          <li 
            className='py-6 text-4xl hover:border-b-4 hover:border-blue-600'>
            <Link onClick={handleClick} to="home" smooth={true} duration={500}>
              Home
            </Link>
          </li>
          <li 
            className='py-6 text-4xl hover:border-b-4 hover:border-blue-600'>
             <Link onClick={handleClick} to="about" smooth={true} duration={500}>
               About
            </Link>
          </li>
          <li 
            className='py-6 text-4xl hover:border-b-4 hover:border-blue-600'>
              <Link onClick={handleClick} to="skills" smooth={true} duration={500}>
                Skills
            </Link>
          </li>
          <li 
            className='py-6 text-4xl hover:border-b-4 hover:border-blue-600'>
              <Link onClick={handleClick} to="projects" smooth={true} duration={500}>
                Projects
              </Link>
          </li>
          <li 
            className='py-6 text-4xl hover:border-b-4 hover:border-blue-600'>
              <Link onClick={handleClick} to="contact" smooth={true} duration={500}>
                Contact
              </Link>
          </li>
        </ul>

      {/* Social Icons */}
      <div className='hidden lg:flex fixed flex-col top-[35%] left-0'>
        <ul>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] lg:hover:ml-[-10px] duration-500 bg-blue-600'>
            <a className='flex justify-between items-center w-full text-gray-300' 
            href='https://www.linkedin.com/in/mariam-owolabi-11b969162' target='_blank' rel='noreferrer'>
              LinkedIn <FaLinkedin size={30}/>
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] lg:hover:ml-[-10px] duration-500 bg-[#333]'>
            <a className='flex justify-between items-center w-full text-gray-300' 
            href='https://github.com/maariam000' target='_blank' rel='noreferrer' >
              Github <FaGithub size={30}/>
            </a>
          </li>
            <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] lg:hover:ml-[-10px] duration-500 bg-[#6fc2b0]'>
            <a className='flex justify-between items-center w-full text-gray-300' 
            href='https://mailto:mariamowolabi16@gmail.com'target='_top'>
              Email <HiOutlineMail size={30}/>
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] lg:hover:ml-[-10px] duration-500 bg-[#565f69]'>
            <a className='flex justify-between items-center w-full text-gray-300' href='https://drive.google.com/file/d/161yXwhT9hZhmuNDZ2lQz7CH7jRwrnxMo/view?usp=drivesdk' target='_blank' rel='noreferrer'>
              Resume <BsFillPersonLinesFill size={30}/>
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] lg:hover:ml-[-10px] duration-500 bg-[#000]'>
            <a className='flex justify-between items-center w-full text-gray-300' href='/'>
              Blog <FaBlog size={30}/>
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Navbar;
